/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 12:09:07
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-28 15:35:16
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/VirtualProduct/common.ts
 */
import { generateCollapseOpen } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { common, defaultStatus } from 'src/pages/ProductEditor/tools/common';
import { randomNumber } from 'src/tools/helper';
import { EnumProductType, EnumServiceType } from 'src/types/common/product';

enum EnumCollapseId {
  ProductInfo = 'ProductInfo',
  GiftCardSetting = 'GiftCardSetting',
  SalesChannelUsage = 'SalesChannelUsage',
  ProductDetail = 'ProductDetail',
  Tags = 'Tags',
  ThumbnailImage = 'ThumbnailImage',
  Quantity = 'Quantity',
  Pricing = 'Pricing',
  Denomination = 'Denomination',
  Attributes = 'Attributes',
  SalesChannelAvailability = 'SalesChannelAvailability',
  'sub-advancedPriceSettingsOpen' = 'sub-advancedPriceSettingsOpen',
  'sub-salesChannelAvailableQuantity' = 'sub-salesChannelAvailableQuantity', //useless
}

enum EnumIds {
  productDetailTitle = 'StoreProductVirtualProductProductDetailTitle',
  productInfoProductName = 'ProductEditorVirtualProductName',
  productAdvancedPriceSettingTable = 'ProductEditorVirtualAdvancedPriceSettingTable',
  productDefaultPrice = 'ProductEditorVirtualPricingSettingDefaultPrice',
  productAvailableQuantityTable = 'ProductEditorAvailableQuantityTable',
  // salesChannelAvailableQuantityTable,
}

const collapses = [
  EnumCollapseId.ProductInfo,
  EnumCollapseId.ProductDetail,
  EnumCollapseId.Tags,
  EnumCollapseId.ThumbnailImage,
  EnumCollapseId.Quantity,
  EnumCollapseId.Pricing,
  EnumCollapseId.SalesChannelAvailability,
  EnumCollapseId['sub-advancedPriceSettingsOpen'],
  EnumCollapseId['sub-salesChannelAvailableQuantity'],
];

const fieldTypeSelectorOptionValue = null;

const generateDefaultProductGiftCardSetting = () => {
  return {
    redemptionCode: '',
    expirationDateSetting: {},
  };
};

const generateDefaultProductInfo = () => {
  return {
    name: '',
    remarks: '',
    codes: [],
    description: '',
    brand: {},
  };
};

const generateDefaultTag = () => {
  return {
    tags: [],
  };
};

const generateDefaultPriceSetting = () => {
  return {
    defaultSalePrice: 0,
    taxRule: null,
  };
};

const generateDefaultSubCollapseData = () => {
  return {
    advancedPriceSettings: [],
    salesChannelAvailableQuantity: [],
  };
};

const generateDefaultStock = () => {
  return {
    stockAvailable: 0,
    inventoryQuota: 0,
    quotaEnabled: false,
    stockAvailableUnlimited: true,
  };
};

const generateDefaultDenomination = () => {
  return {
    currency: 'HKD',
    denominations: [0],
  };
};

const generateNewOption = (index?) => {
  return `Option ${index || 1}`;
};

const convertOptionToRedux = (item) => {
  return { value: item.value, draggableId: randomNumber(), uuid: item.uuid };
};

const generateNewService = (index, required?) => {
  return {
    uuid: randomNumber(),
    required: required,
    title: `Customer Field ${index}`,
    type: EnumServiceType.Text,
    // fieldType: EnumServiceType.Text,
    // optionType: EnumServiceType.Radio,
    placeHolder: '',
    charLimit: 100,
    options: [generateNewOption(1)],
    maxSelection: 1,
  };
};

const convertProductDetailToServer = (detail) => {
  const { fieldType, optionType, options, ...rest } = detail;
  // const _options = options.map((i) => i.value);
  if (fieldType === EnumServiceType.Text) {
    return { ...rest, type: EnumServiceType.Text, options };
  } else {
    return { ...rest, type: optionType, options };
  }
};

const convertProductDetailToRedux = (detail) => {
  const { type, options, ...rest } = detail;

  if (type === EnumServiceType.Text) {
    return {
      ...rest,
      fieldType: EnumServiceType.Text,
      optionType: EnumServiceType.Radio,
      options: options.map((i) => convertOptionToRedux(i)),
    };
  } else {
    return {
      ...rest,
      fieldType: EnumServiceType.Selector,
      optionType: type,
      options: options.map((i) => convertOptionToRedux(i)),
    };
  }
};

const convertProductDetailMapToArr = ({ order, map }) => {
  const _return = [];
  order.forEach((i) => {
    const _temp = { ...convertProductDetailToServer(map[i]), uuid: i }; //再来一层转换
    _return.push(_temp);
  });
  return _return;
};

const convertProductDetailArrToMap = (arr) => {
  const data = {};
  const order = [];
  arr.forEach((i) => {
    const { uuid, ...rest } = i || {};
    data[uuid] = convertProductDetailToRedux(rest);
    order.push(uuid);
  });

  return { data, order };
};

const generateNewServiceInMap = ({ index }: { index: number }) => {
  //没啥用
  const _inArr = generateNewService(index);
  const { data, order } = convertProductDetailArrToMap([_inArr]);
  return { data, order };
};

const generateDefaultProductDetail = () => {
  const _inArr = generateNewService(1, true);
  const { data, order } = convertProductDetailArrToMap([_inArr]);
  return {
    serviceDetails: data,
    serviceDetailsOrder: order,
  };
};

const collapseOpen = generateCollapseOpen(collapses);

const defaultData = {
  ...common,
  ...defaultStatus,
  productType: EnumProductType.Service,
  collapseOpen,
  linkedSalesChannels: [],
  productGiftCardSetting: generateDefaultProductGiftCardSetting(),
  productInfo: generateDefaultProductInfo(),
  tags: generateDefaultTag(),
  priceSettings: generateDefaultPriceSetting(),
  stock: generateDefaultStock(),
  productDenominations: generateDefaultDenomination(),
  salesChannelUsageUuids: [],
  ...generateDefaultProductDetail(),
  ...generateDefaultSubCollapseData(),
  thumbnailImage: null,
  hasBeenSold: false,
};
export { generateDefaultDenomination, generateDefaultProductDetail };
export {
  defaultData,
  EnumCollapseId,
  EnumServiceType,
  generateNewService,
  convertProductDetailArrToMap,
  convertProductDetailMapToArr,
  fieldTypeSelectorOptionValue,
  convertProductDetailToRedux,
  convertProductDetailToServer,
  generateNewServiceInMap,
  generateNewOption,
  EnumIds,
  collapseOpen,
  convertOptionToRedux,
};
